import { IMAGING_FILTER_DATA_REQUEST, IMAGING_FILTER_DATA_SUCCESS, IMAGING_FILTER_DATA_FAILURE, IMAGING_CAT_DETAILS_DATA_REQUEST, IMAGING_CAT_DETAILS_DATA_SUCCESS, IMAGING_CAT_DETAILS_DATA_FAILURE, IMAGING_NET_CAT_DETAILS_DATA_REQUEST, IMAGING_NET_CAT_DETAILS_DATA_SUCCESS, IMAGING_NET_CAT_DETAILS_DATA_FAILURE, IMAGING_EXPORT_LINK_REQUEST, IMAGING_EXPORT_LINK_SUCCESS, IMAGING_EXPORT_LINK_FAILURE, IMAGING_CATEGORY_VIEW_DATA_REQUEST, IMAGING_CATEGORY_VIEW_DATA_SUCCESS, IMAGING_CATEGORY_VIEW_DATA_FAILURE } from '../../actions/actionTypes';

interface ImagingReducerState {
  filterDetails: any;
  filterDetailsIsLoading: boolean;
  filterDetailsError: string | null;
  imagingCatDetails: any;
  imagingCatDetailsIsLoading: boolean;
  imagingCatDetailsError: string | null;
  imagingNetCatDetails: any;
  imagingNetCatDetailsIsLoading: boolean;
  imagingNetCatDetailsError: string | null;
  imagingExportDetails: any;
  imagingExportDetailsIsLoading: boolean;
  imagingExportDetailsError: string | null;
  imagingCatViewData: any;
  imagingCatViewDataIsLoading: boolean;
  imagingCatViewDataError: string | null;
}

const initialState: ImagingReducerState = {
  filterDetails: {},
  filterDetailsIsLoading: false,
  filterDetailsError: null,
  imagingCatDetails: {},
  imagingCatDetailsIsLoading: true,
  imagingCatDetailsError: null,
  imagingNetCatDetails: {},
  imagingNetCatDetailsIsLoading: false,
  imagingNetCatDetailsError: null,
  imagingExportDetails: {},
  imagingExportDetailsIsLoading: false,
  imagingExportDetailsError: null,
  imagingCatViewData: {},
  imagingCatViewDataIsLoading: false,
  imagingCatViewDataError: null,
};

const ImagingReducer = (
  state = initialState,
  action: { type: string; payload?: any }
): ImagingReducerState => {
  switch (action.type) {
    case IMAGING_FILTER_DATA_REQUEST:
      return {
        ...state,
        filterDetailsIsLoading: true,
      };

    case IMAGING_FILTER_DATA_SUCCESS:
      return {
        ...state,
        filterDetails: action.payload,
        filterDetailsIsLoading: false,
      };

    case IMAGING_FILTER_DATA_FAILURE:
      return {
        ...state,
        filterDetailsError: action.payload,
        filterDetailsIsLoading: false,
      };

    case IMAGING_CAT_DETAILS_DATA_REQUEST:
      return {
        ...state,
        imagingCatDetailsIsLoading: true,
      };

    case IMAGING_CAT_DETAILS_DATA_SUCCESS:
      return {
        ...state,
        imagingCatDetails: action.payload,
        imagingCatDetailsIsLoading: false,
      };

    case IMAGING_CAT_DETAILS_DATA_FAILURE:
      return {
        ...state,
        imagingCatDetailsError: action.payload,
        imagingCatDetailsIsLoading: false,
      };

    case IMAGING_NET_CAT_DETAILS_DATA_REQUEST:
      return {
        ...state,
        imagingNetCatDetailsIsLoading: true,
      };

    case IMAGING_NET_CAT_DETAILS_DATA_SUCCESS:
      return {
        ...state,
        imagingNetCatDetails: action.payload,
        imagingNetCatDetailsIsLoading: false,
      };

    case IMAGING_NET_CAT_DETAILS_DATA_FAILURE:
      return {
        ...state,
        imagingNetCatDetailsError: action.payload,
        imagingNetCatDetailsIsLoading: false,
      };


    case IMAGING_EXPORT_LINK_REQUEST:
      return {
        ...state,
        imagingExportDetails: {},
        imagingExportDetailsIsLoading: true,
      };

    case IMAGING_EXPORT_LINK_SUCCESS:
      return {
        ...state,
        imagingExportDetails: action.payload,
        imagingExportDetailsIsLoading: false,
      };

    case IMAGING_EXPORT_LINK_FAILURE:
      return {
        ...state,
        imagingExportDetails: {},
        imagingExportDetailsError: action.payload,
        imagingExportDetailsIsLoading: false,
      };


    case IMAGING_CATEGORY_VIEW_DATA_REQUEST:
      return {
        ...state,
        imagingCatViewDataIsLoading: true,
      };

    case IMAGING_CATEGORY_VIEW_DATA_SUCCESS:
      return {
        ...state,
        imagingCatViewData: action.payload,
        imagingCatViewDataIsLoading: false,
      };

    case IMAGING_CATEGORY_VIEW_DATA_FAILURE:
      return {
        ...state,
        imagingCatViewDataError: action.payload,
        imagingCatViewDataIsLoading: false,
      };


    default:
      return state;
  }
};

export default ImagingReducer;